import React from 'react';
import VisualizationDocPage from '@splunk/visualizations-shared/VisualizationDocPage';
import EncodingDoc from '@splunk/dashboard-visualizations/common/EncodingDoc';
import OptionsDoc from '@splunk/dashboard-visualizations/common/OptionsDoc';
import DocExample from '@splunk/react-docs/DocExample';

import RangeValueCode from '!!raw-loader!./examples/RangeValue';
import USAInsetsCode from '!!raw-loader!./examples/USAInsets';
import BasicUSACode from '!!raw-loader!./examples/BasicUSA';
import EquirectangularWorldCode from '!!raw-loader!./examples/EquirectangularWorld';
import WorldCode from '!!raw-loader!./examples/WorldMap';
import AutoGradientCode from '!!raw-loader!./examples/AutoGradient';
import MultiGradientCode from '!!raw-loader!./examples/MultiGradient';
import GradientGreenBlueCode from '!!raw-loader!./examples/GradientGreenBlue';
import BackgroundColorCode from '!!raw-loader!./examples/BackgroundColor';

import RangeValueExample from './examples/RangeValue';
import USAInsetsExample from './examples/USAInsets';
import BasicUSAExample from './examples/BasicUSA';
import EquirectangularWorldExample from './examples/EquirectangularWorld';
import WorldExample from './examples/WorldMap';
import AutoGradientExample from './examples/AutoGradient';
import MultiGradientExample from './examples/MultiGradient';
import GradientGreenBlueExample from './examples/GradientGreenBlue';
import BackgroundColorExample from './examples/BackgroundColor';

import doc from './definition';
import optionsSchema from '../optionsSchema';

export default () => (
    <VisualizationDocPage
        title="Choropleth"
        examplesSection={[
            <DocExample
                title="Basic US Choropleth"
                key="BasicUSAChoropleth"
                code={BasicUSACode}
                example={BasicUSAExample}
            />,
            <DocExample
                title="Custom Background Color"
                key="backgroundcolor"
                code={BackgroundColorCode}
                example={BackgroundColorExample}
            />,
            <DocExample
                title="Encoding format - Auto Linear Gradient"
                key="AutoGradients"
                code={AutoGradientCode}
                example={AutoGradientExample}
            />,
            <DocExample
                title="Encoding format - Linear Gradient to green and blue"
                key="GradientGreenBlue"
                code={GradientGreenBlueCode}
                example={GradientGreenBlueExample}
            />,
            <DocExample
                title="Encoding format - Multiple Linear Color Gradients"
                key="MultiGradient"
                code={MultiGradientCode}
                example={MultiGradientExample}
            />,
            <DocExample
                title="Encoding format - Specify Rangevalue."
                key="RangeValue1Choropleth"
                code={RangeValueCode}
                example={RangeValueExample}
            />,
            <DocExample
                title="US Choropleth with custom inset maps for Alaska and Hawaii"
                key="USAInsets"
                code={USAInsetsCode}
                example={USAInsetsExample}
            />,
            <DocExample
                title="World Choropleth"
                key="WorldChoropleth"
                code={WorldCode}
                example={WorldExample}
            />,
            <DocExample
                title="World Choropleth - Equirectangular Projection"
                key="EquirectangularWorldChoropleth"
                code={EquirectangularWorldCode}
                example={EquirectangularWorldExample}
            />,
        ]}
        optionSection={<OptionsDoc options={optionsSchema} />}
        encodingSection={<EncodingDoc encoding={doc.encoding} />}
    />
);
